export var Mutation;
(function (Mutation) {
    Mutation["SET_TOKEN"] = "SET_TOKEN";
    Mutation["SET_USER_INFO"] = "SET_USER_INFO";
    Mutation["SET_TIPS_POP"] = "SET_TIPS_POP";
    Mutation["SING_OUT"] = "SING_OUT";
})(Mutation || (Mutation = {}));
